import { render, staticRenderFns } from "./SpecialOfferTable.vue?vue&type=template&id=5f96dc17&"
import script from "./SpecialOfferTable.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports